const PACKAGE_INSTANCE_KEY = Symbol.for('@zvuk-b2b/modal-host');

type GlobalWithModalHostPackage = typeof globalThis & { [PACKAGE_INSTANCE_KEY]?: object };

const packageInstance = {};

const globalScope = globalThis as GlobalWithModalHostPackage;

globalScope[PACKAGE_INSTANCE_KEY] ??= packageInstance;

export const isDuplicatePackageInstance = () => globalScope[PACKAGE_INSTANCE_KEY] !== packageInstance;
